<template>
  <b-form-group
    label="氏"
  >
    <b-form-input
      type="text"
      v-model="model"
    >
    </b-form-input>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/edit',
      attribute: 'lastName'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
